/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  GetPricingParams,
  SuccessBodyCountryPricingResponse
} from '.././_model';

import { httpsInstance } from '../../httpClient';
import type { ErrorType } from '../../httpClient';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * 특정 국가의 모든 플랜 가격 정보를 조회합니다. 해당 국가의 가격 정보가 없으면 미국(US) 가격으로 대체됩니다.
 * @summary 국가별 플랜 가격 조회
 */
export const getPricing = (
    params: GetPricingParams,
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<SuccessBodyCountryPricingResponse>(
      {url: `/pricing`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetPricingQueryKey = (params: GetPricingParams,) => {
    return [`/pricing`, ...(params ? [params]: [])] as const;
    }

    
export const getGetPricingQueryOptions = <TData = Awaited<ReturnType<typeof getPricing>>, TError = ErrorType<unknown>>(params: GetPricingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPricing>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPricingQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPricing>>> = ({ signal }) => getPricing(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPricing>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPricingQueryResult = NonNullable<Awaited<ReturnType<typeof getPricing>>>
export type GetPricingQueryError = ErrorType<unknown>


export function useGetPricing<TData = Awaited<ReturnType<typeof getPricing>>, TError = ErrorType<unknown>>(
 params: GetPricingParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPricing>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPricing>>,
          TError,
          Awaited<ReturnType<typeof getPricing>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPricing<TData = Awaited<ReturnType<typeof getPricing>>, TError = ErrorType<unknown>>(
 params: GetPricingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPricing>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPricing>>,
          TError,
          Awaited<ReturnType<typeof getPricing>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPricing<TData = Awaited<ReturnType<typeof getPricing>>, TError = ErrorType<unknown>>(
 params: GetPricingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPricing>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary 국가별 플랜 가격 조회
 */

export function useGetPricing<TData = Awaited<ReturnType<typeof getPricing>>, TError = ErrorType<unknown>>(
 params: GetPricingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPricing>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPricingQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetPricingSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPricing>>, TError = ErrorType<unknown>>(params: GetPricingParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPricing>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPricingQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPricing>>> = ({ signal }) => getPricing(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPricing>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPricingSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPricing>>>
export type GetPricingSuspenseQueryError = ErrorType<unknown>


export function useGetPricingSuspense<TData = Awaited<ReturnType<typeof getPricing>>, TError = ErrorType<unknown>>(
 params: GetPricingParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPricing>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPricingSuspense<TData = Awaited<ReturnType<typeof getPricing>>, TError = ErrorType<unknown>>(
 params: GetPricingParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPricing>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPricingSuspense<TData = Awaited<ReturnType<typeof getPricing>>, TError = ErrorType<unknown>>(
 params: GetPricingParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPricing>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary 국가별 플랜 가격 조회
 */

export function useGetPricingSuspense<TData = Awaited<ReturnType<typeof getPricing>>, TError = ErrorType<unknown>>(
 params: GetPricingParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPricing>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPricingSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



